import { useEffect, useState } from "react";
import "./DropDownList.scss";
import DropdownList from "react-widgets/DropdownList";
import "react-widgets/scss/styles.scss";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";

/*DOCUMENTAÇÃO
    https://jquense.github.io/react-widgets/docs/DropdownList 
*/

export default function DropDownList({
  dataKey = "id",
  textField = "key",
  data = [{ id: 0, key: "sem dados" }],
  dataDisabled = [], //passar os nome para desativar.
  disabled = false, //Desativa totalmente
  type = "text",
  placeholder = "",
  value = "",
  title = "",
  onChange = () => null,
  className = "",
  theme = "1",
  defaultValue = "",
  loading = false,
  name = "", //Item para campo obrigatorio
  required = false, //Item para campo obrigatorio
  register = null, //Item para campo obrigatorio
  registerProps = {}, //Item para campo obrigatorio
  errors = null, //Item para campo obrigatorio
  requiredUseValue = false, //Item para usar o value/change
  //Button
  button = false,
  iconButton = "pesquisar",
  titleButton = "",
  typeButton = "button",
  onClickButton = () => null,
  //ToolTip
  tooltip = false,
  tooltipId = "",
  tooltipIcon = <i className="fa-solid fa-hexagon-exclamation"></i>,
  tooltipDescricao = "",
  tooltipIconColor = "#ff7575c9",
  //Carregar ao click
  flgCarregarClick = false,
  functionCarregarClick = () => null,
}) {
  const [dataSlice, setDataSlice] = useState([]);

  useEffect(() => {
    if (data.length > 1000) {
      setDataSlice(data.slice(0, 100));
    }
  }, [data]);

  const onReturn = (value) => {
    if (register !== null) {
      onChange(name, value[textField], value);
      return;
    }
    return onChange(value);
  };

  const handleChange = (e) => {
    return onReturn(e);
  };

  const handleSearch = (value) => {
    const datafilter = data.filter((item) =>
      Object.values(item).some((val) =>
        String(val).toLowerCase().includes(value.toLowerCase()),
      ),
    );
    setDataSlice(datafilter.slice(0, 100));
  };

  const handleToggle = (isOpen) => {
    if (isOpen) {
      functionCarregarClick();
    }
  };

  return (
    <div
      className={`dropdownlist ${className} theme${theme}`}
      {...(register && {
        ...register(name, {
          required: required,
          ...registerProps,
        }),
      })}
    >
      <div style={{ display: "flex" }} className="title-tooltip">
        {title && <p>{title}</p>}
        {tooltip && (
          <p
            data-tooltip-id={tooltipId}
            data-tooltip-html={tooltipDescricao}
            className="tooltipInput"
            style={{ color: tooltipIconColor, cursor: "pointer" }}
          >
            {tooltipIcon}
          </p>
        )}
      </div>
      <div
        className={`${disabled ? "disabled" : ""}`}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <DropdownList
          dataKey={dataKey}
          textField={textField}
          value={value}
          placeholder={placeholder}
          onChange={handleChange}
          defaultValue={defaultValue}
          data={data.length > 1000 ? dataSlice : data}
          busy={loading}
          disabled={dataDisabled}
          readOnly={disabled}
          onSearch={handleSearch}
          filter="contains"
          {...(flgCarregarClick && {
            onToggle: handleToggle, //Validação de um campo que não pode ser nulo aqui fora.
          })}
        />
        {button && (
          <ButtonIcon
            {...{
              //Tipo de botão
              [iconButton]: true,
              // title
              [`title${
                iconButton.charAt(0).toUpperCase() + iconButton.slice(1)
              }`]: titleButton,
              // on
              [`on${iconButton.charAt(0).toUpperCase() + iconButton.slice(1)}`]:
                onClickButton,
              //type
              [`type${
                iconButton.charAt(0).toUpperCase() + iconButton.slice(1)
              }`]: typeButton,
              //disabled
              [`disabled${
                iconButton.charAt(0).toUpperCase() + iconButton.slice(1)
              }`]: disabled,
            }}
          />
        )}
      </div>
      {required && errors && errors[name] && (
        <span className="dropdownMsgError">{errors[name].message}</span>
      )}
    </div>
  );
}

DropDownList.defaultProps = {};
